import React, { useEffect, useState } from "react";
import { addBookmark, fetchBookmarks } from "../../../services/bookmark";
import FIlledBookMArk from "../filledBookmark/FIlledBookMArk";
import UnFilledBookMark from "../unFilledBookMark/UnFilledBookMark";
import { toast } from "react-toastify";

const BookMArkAction = ({
  tableId,
  fetchData,
  userId,
  setLocalBookmarkCount,
  toggleBookmark,
  setIsVisible,
}) => {
  const [tableIds, setTableIds] = useState([]);
  const accessToken = localStorage.getItem("@user");
  const getBookmarks = () => {
    fetchBookmarks()
      .then((data) => {
        const ids = data.map((item) => item.table_details.id);
        setTableIds(ids);
        // fetchData();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const myId = localStorage.getItem("@userAccount");

  const handleAddBookmark = async () => {
    if (!accessToken) {
      setIsVisible(true);
      return;
    }
    if (Number(userId) === Number(myId)) {
      toast.warning("Sorry But you cant wishlist your own table!", {
        position: "top-center",
      });
      return;
    } else {
    }
    try {
      const result = await addBookmark(tableId);
      console.log("Bookmark added successfully:", result);
      // fetchData();
      getBookmarks();
      if (!tableIds.includes(tableId)) {
        toast.success("wishlist added successfully!", {
          position: "top-right",
        });
        setLocalBookmarkCount((prev) => prev + 1); // Update local count
        toggleBookmark(tableId);
      } else {
        toast.warning("wishlist removed successfully!", {
          position: "top-right",
        });
        setLocalBookmarkCount((prev) => prev - 1); // Update local count
        toggleBookmark(tableId);
      }
    } catch (error) {
      console.error("Failed to add bookmark:", error);
      toast.error("Sorry cant add this to your wishlist!", {
        position: "top-center",
      });
    }
  };

  useEffect(() => {
    getBookmarks();
  }, []);

  return (
    <>
      <div className="hidden lg:inline" onClick={handleAddBookmark}>
        {tableIds.includes(tableId) ? <FIlledBookMArk /> : <UnFilledBookMark />}
      </div>
      <div className="inline lg:hidden" onClick={handleAddBookmark}>
        {tableIds.includes(tableId) ? (
          <FIlledBookMArk />
        ) : (
          <UnFilledBookMark mobile={true} />
        )}
      </div>
      <div className="save-text hidden xl:inline">
        {tableIds.includes(tableId) ? "Wishlist Added" : "Add to wishlist"}
      </div>
    </>
  );
};

export default BookMArkAction;
